import Container from '@/landing/component/container/nogap'

import Head from "@helper/seo/head";

const ProhibitedConduct = () => {
  return (
    <Container>
      <Head
        title="SellOn | Prohibited Conduct"
        type="website"
        url="https://sellon.net"
        siteName="Sellon Tech"
        image="/media/logo/main.png"
      />
      <h1 className='text-center text-3xl font-bold mb-16'>Prohibited Conduct</h1>
      <p className="ml-3 mr-3">
        By using our Service, you agree to follow the rules and manners as
        included in our Terms and Policies. By using our Service, you agree
        not to engage in the following Prohibited Conduct:
      </p>
      <div className='pt-3 ml-3 mr-3'>
        <ol className="list-inside grid gap-3">
          <li>
            <strong>1. Description of the Service</strong>
            <div className=''>
              <ul className="list-disc list-outside mb-3 ml-5 pl-4">
                <li className='pl-2 -indent-2'>
                  Using the Service for any illegal purpose or in violation of any
                  local, national, or international law or regulation; violate, or
                  encourage others to violate, any right of a third party, including
                  by infringing or misappropriating any third party intellectual
                  property right;
                </li>
                <li className='pl-2 -indent-2'>
                  Posting, uploading, or distributing any User Content or other
                  content that is unlawful, defamatory, libellous, inaccurate, or that
                  a reasonable person could consider objectionable, profane, indecent,
                  pornographic, harassing, threatening, embarrassing, hateful,
                  offensive or otherwise inappropriate;
                </li>
                <li className='pl-2 -indent-2'>
                  Interfering with security-related features of the Service, including
                  by: (a) disabling or circumventing features that prevent or limit
                  use or copying of any content; or (b) reverse engineering or
                  otherwise attempting to discover the source code of any portion of
                  the Service except to the extent that the activity is expressly
                  permitted by applicable law or regulation;
                </li>
                <li className='pl-2 -indent-2'>
                  Interfering with the operation of the Service or any user’s
                  enjoyment of the Service, including by: (a) uploading or otherwise
                  disseminating any virus, adware, spyware, worm, or other malicious
                  code; (b) making any unsolicited offer or advertisement to another
                  user of the Service; (c) attempting to collect, personal information
                  about another user or third party without consent; or (d)
                  interfering with or disrupting any network, equipment, or server
                  connected to or used to provide the Service, or violating any
                  regulation, policy, or procedure of any network, equipment, or
                  server; use any robot, spambot, spider, crawler, scraper or other
                  automated means or interface not provided by us to access the
                  Service or to extract data;
                </li>
                <li className='pl-2 -indent-2'>
                  Selling or otherwise transferring the access granted under these
                  Terms or any right or ability to view, access, or use any Material
                </li>
              </ul>
              <p>
                SellOn may take any of the following actions on an account that has
                violated our Policies or if SellOn suspects prohibited conduct has
                occurred:
              </p>
              <ul className="list-disc list-inside mb-3">
                <li className='pl-5 -indent-5'>
                  We may contact Users or utilize a third party verification service
                  to verify User Information.
                </li>
                <li className='pl-5 -indent-5'>
                  SellOn may refuse a user access to or suspend a user from all or
                  part of the Service until the completion of such verification.
                </li>
                <li className='pl-5 -indent-5'>
                  SellOn may prohibit a user that is terminated for engaging in any
                  prohibited conduct from using and accessing any future services
                  provided by SellOn.
                </li>
              </ul>
              <p>
                We may update our list of Prohibited Conduct from time to time. The
                following is a list of actions SellOn restricts users from
                participating in:
              </p>
            </div>
          </li>
          <li>
            <strong>Transactions:</strong>
            <div>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Encouraging payments outside of SellOn</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Proposing or completing a transaction in person</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Proposing a trade, exchange, partial exchange, or swap</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>
                  Two members reducing the price of their own items and purchasing
                  from each other
                </li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Requiring or encouraging a direct transfer of a product</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Returns unauthorized by SellOn</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Using SellOn for the purpose of money laundering</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>
                  Using SellOn to buy and sell from yourself, or to send funds to
                  yourself
                </li>
              </ul>
            </div>
          </li>
          <li>
            <strong>Accounts:</strong>
            <div>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Having multiple SellOn accounts</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Creating a new account after being permanently banned</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>
                  Creating a new account to bypass restrictions on another account
                </li>
              </ul>
            </div>
          </li>
          <li>
            <strong>Listings:</strong>
            <div>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Listing a Prohibited Item</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Creating multiple listings of the same item</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Excessive reposting of previously listed items</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Listing an item that is not actually for sale</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Listing items without the intent to sell</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Listing items with the intent to sell to certain users only</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Using a stock or advertisement photo as the only image</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Using photos that you do not own or have taken yourself</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Using another member's photos or words without their consent</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Setting a false brand</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Listings that do not specify size, color, quantity, etc.</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>
                  Listings that require users to specify size, color, quantity, etc.
                </li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Listing in auction, raffle, or giveaway format</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>
                  Listing another user’s personal information in a manner other than
                  specified by SellOn
                </li>
              </ul>
            </div>
          </li>
          <li>
            <strong>Solicitations:</strong>
            <div>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Soliciting users to an external website</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Soliciting transactions to an external website</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Soliciting users to provide personal information</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>
                  Soliciting other users to list Prohibited Items or engage in
                  Prohibited Conduct
                </li>
              </ul>
            </div>
          </li>
          <li>
            <strong>Other:</strong>
            <div>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Threats</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Slander</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Trolling</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Indecent behavior</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Spamming</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Copyright infringement</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Posting false information</li>
              </ul>
              <ul className="list-disc list-inside">
                <li className='pl-5 -indent-5'>Actions for the intentions of dating</li>
              </ul>
            </div>
          </li>
        </ol>
        
      </div>
    </Container>
  );
};

export default ProhibitedConduct;
